import SetPasswordByWebsiteLink from 'pages/Auth/SetPasswordByWebsiteLink/SetPasswordByWebsiteLink';

import { RouteObject } from 'types/route';

import { AppModules, AuthSteps } from 'constants/enums';
import {
  ACCESS_PENDING,
  APPLICATIONS,
  AUTH,
  CREATE_JOB,
  EDIT_JOB,
  EMPLOYMENT_CONFIRMATION,
  HOME,
  JOBS,
  JOBSEEKERS,
  RECRUITMENT_OVERVIEW_REPORT,
  RESET_PASSWORD,
  SETUP_PASSWORD,
  SET_PASSWORD
} from 'constants/path';

import RouteAuthLayout from './components/RouteAuthLayout';
import RouteWithLayout from './components/RouteWithLayout';
import {
  AccessPendingPage,
  ApplicationsPage,
  AuthPage,
  CreateJobPage,
  EditJobPage,
  EmploymentConfirmation,
  HomePage,
  JobsPage,
  JobseekersPage,
  RecruitmentOverviewReportPage
} from './lazyPages';
import { BREADCRUMB_KEYS } from './utils/breadcrumbKeys';
import { createRoute } from './utils/createRoute';

const getRoutes = (): RouteObject[] => [
  createRoute(
    HOME,
    'HOME_ROOT',
    <RouteWithLayout />,
    true,
    null,
    BREADCRUMB_KEYS.home,
    [
      createRoute(HOME, 'HOME', <HomePage />, true, null, BREADCRUMB_KEYS.home),
      createRoute(
        JOBS,
        'JOBS',
        <JobsPage />,
        true,
        AppModules.Jobs,
        BREADCRUMB_KEYS.jobs
      ),
      createRoute(
        `${JOBS}/:jobId`,
        'JOBS',
        <JobsPage />,
        true,
        AppModules.Jobs
      ),
      createRoute(
        CREATE_JOB,
        'CREATE_JOB',
        <CreateJobPage />,
        true,
        AppModules.Jobs,
        'Add job'
      ),
      createRoute(
        EDIT_JOB,
        'EDIT_JOB',
        <EditJobPage />,
        true,
        AppModules.Jobs,
        BREADCRUMB_KEYS.editJob
      ),
      createRoute(
        JOBSEEKERS,
        'JOBSEEKERS',
        <JobseekersPage />,
        true,
        AppModules.Jobseekers,
        BREADCRUMB_KEYS.jobseekers
      ),
      createRoute(
        `${JOBSEEKERS}/:jobseeker_id`,
        'JOBSEEKERS',
        <JobseekersPage />,
        true,
        AppModules.Jobseekers,
        BREADCRUMB_KEYS.jobseekers
      ),
      createRoute(
        APPLICATIONS,
        'APPLICATIONS',
        <ApplicationsPage />,
        true,
        AppModules.Applications,
        BREADCRUMB_KEYS.applications
      ),
      createRoute(
        `${APPLICATIONS}/:application_id`,
        'APPLICATIONS',
        <ApplicationsPage />,
        true,
        AppModules.Applications,
        BREADCRUMB_KEYS.applications
      ),
      createRoute(
        RECRUITMENT_OVERVIEW_REPORT,
        'RECRUITMENT_OVERVIEW_REPORT',
        <RecruitmentOverviewReportPage />,
        true,
        AppModules.RecruitmentOverviewReport,
        BREADCRUMB_KEYS.analytics
      )
    ]
  ),
  createRoute(HOME, 'AUTH_ROOT', <RouteAuthLayout />, false, null, 'Auth', [
    createRoute(
      AUTH,
      'AUTH',
      <AuthPage />,
      false,
      null,
      BREADCRUMB_KEYS.login,
      undefined,
      true,
      false
    ),
    createRoute(
      RESET_PASSWORD,
      'RESET_PASSWORD',
      <AuthPage initialStep={AuthSteps.passwordUpdate} />,
      false,
      null,
      BREADCRUMB_KEYS.resetPassword
    ),
    createRoute(
      SETUP_PASSWORD,
      'SETUP_PASSWORD',
      <AuthPage initialStep={AuthSteps.setUpPassword} />,
      false,
      null,
      BREADCRUMB_KEYS.setupPassword
    ),
    createRoute(
      SET_PASSWORD,
      SET_PASSWORD,
      <SetPasswordByWebsiteLink />,
      false,
      null,
      BREADCRUMB_KEYS.setupPassword
    )
  ]),
  createRoute(
    EMPLOYMENT_CONFIRMATION,
    'EMPLOYMENT_CONFIRMATION',
    <EmploymentConfirmation />,
    false,
    null,
    BREADCRUMB_KEYS.employmentConfirmation,
    undefined,
    true,
    false
  ),
  createRoute(
    ACCESS_PENDING,
    'ACCESS_PENDING',
    <AccessPendingPage />,
    false,
    null
  )
];

export default getRoutes;
